// extracted by mini-css-extract-plugin
export default {"config-isPhone-title":"subAboutUs_config-isPhone-title__mhYAT","config-isPhone-text":"subAboutUs_config-isPhone-text__rf8x+"};